(function ($) {
    $(function () {
        var $window = $(window);
        // Phone nav click function
        $('.sub-menu').parent('li').addClass('has-sub-nav')
        // if ($window.width() > 768) {
        //     $('.has-sub-nav').each(function () {
        //         var $this = $(this);

        //         $this.mouseenter(function () {
        //             $this.find('.sub-menu').fadeIn()
        //             $("body").addClass("subnavShown");
        //         })
        //         $this.mouseleave(function () {
        //             $this.find('.sub-menu').fadeOut();
        //             $("body").removeClass("subnavShown");
        //         })
        //     })
        // }

        $(window).on('resize load', function () {
            var navHeight = $('#shopify-section-header').outerHeight();
            $('.main-content-wrap .hero-wrap').css('min-height', $(window).height() - navHeight);
        });

        if ($window.width() < 992) {
            $('.has-sub-nav > a').click(function (e) {
                // e.preventDefault();
                $('.sub-menu').show()
                $("body").addClass("navShown");
            })
            $('.hamburger').click(function () {
                $("body").toggleClass("navShown");
            });
            $('.hamburger').click(function () {
                if ($('.sub-menu:visible').length) {
                    $('.sub-menu').hide()
                    $("body").addClass("navShown");
                }
            })
        }

        $('.cart-icon a').click(function (e) {
            e.preventDefault();
            $("body").toggleClass("cartShown");
        });

        $('.cart-heading-cta').click(function (e) {
            e.preventDefault();
            $("body").removeClass("cartShown");
        });
        $('.cart-backdrop').click(function () {
            $("body").removeClass("cartShown");
        });

        if ($('.get-the-look-slider-item-wrap').length) {
            $('.get-the-look-slider-item-wrap').slick({
                arrows: false,
                infinite: true,
                autoplay: true,
                navigation: false,
                autoplaySpeed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                centerMode: false,
                focusOnSelect: false,
                fade: true,
                adaptiveHeight: true,
                pauseOnHover: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                swipe : false,
            });
            $(window).on('resize', function () {
                $('.get-the-look-slider-item-wrap').slick('resize');
            });
        }

        $('.instagram-feed-marquee').marquee({
            direction: 'left',
            duration: 50000,
            gap: 50,
            delayBeforeStart: 0,
            duplicated: true,
            startVisible: true
        });
        $('.instagram-feed-marquee-mob').marquee({
            direction: 'left',
            duration: 20000,
            gap: 50,
            delayBeforeStart: 0,
            duplicated: true,
            startVisible: true
        });

        // $('.template-collection .main-nav__url, .footer-url__shop-menu').click(function(e){
        //     e.preventDefault();
        //     var nav_url = $(this).attr('href');
        //     window.location.href = nav_url;
        //     location.reload();
        // })
        
        
        
        
        
        
        
        if ($('.shop-item-wrap').length) {
            $('.shop-item-wrap').slick({
                autoplay: true,
                autoplaySpeed: 1500,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                arrows: false,
                dots: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                swipe : false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: 'unslick'
                    }
                ]
            })

            $(window).on('resize', function () {
                $('.shop-item-wrap').slick('resize');
            });
        }

        if ($('.promise-item-wrap').length) {
            $('.promise-item-wrap').slick({
                autoplay: false,
                autoplaySpeed: 1500,
                slidesToShow: 3,
                slidesToScroll: 2,
                mobileFirst: true,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: 'unslick'
                    }
                ]
            });

            $(window).on('resize', function () {
                $('.promise-item-wrap').slick('resize');
            });
        }

        

        $('.article-page__related-articles').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: 'unslick'
                }
            ]
        });
        $(window).on('resize', function () {
            $('.article-page__related-articles').slick('resize');
        });



        if ($('.instagram-feed-item-wrap').length) {
            $('.instagram-feed-item-wrap').slick({
                autoplay: true,
                autoplaySpeed: 1500,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                arrows: false,
                dots: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                swipe : false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: 'unslick'
                    }
                ]
            })
            $(window).on('resize', function () {
                $('.instagram-feed-item-wrap').slick('resize');
            });
        }

        if ($(window).width() < 769) {
            $(".footer-acordion").each(function () {
                var $this = $(this);
                $this.find("h6").on("click touch", function () {
                    $(".footer-acordion").removeClass("active")
                    $(".footer-acordion ul").slideUp();
                    if ($this.find("ul:visible").length) {
                        $(".footer-acordion").removeClass("active")
                        $(".footer-acordion ul").slideUp();
                    } else {
                        $this.addClass("active")
                        $(".footer-acordion ul").slideUp();
                        $this.find("ul").slideDown();
                    }
                })
            })
        }


        $('.scroll-nav-slide-trigger a, .see-different-products ').click(function (e) {
            e.preventDefault();
            $('body').addClass('slide-out-show');
            $('html').addClass('slideShown');
        })

        $('.image-text-advanced__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: 'unslick'
                }
            ]
        });

        $('.mob-menu__has-children > a').click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).next().slideToggle();
        });
        $(document).click(function () {
            $('.mob-menu__children').slideUp();
        });

        // ANIMATION CHECK IF IN VIEW
        var $animation_elements = $('.anim-el');
        var $window = $(window);

        function check_if_in_view() {
            var window_height = $window.height();
            var insetAmount = window_height / 20 // fifth of the screen
            var window_top_position = $window.scrollTop();
            var window_bottom_position = (window_top_position + window_height) - insetAmount;

            $.each($animation_elements, function () {
                var $element = $(this);
                var element_height = $element.outerHeight();
                var element_top_position = $element.offset().top;
                var element_bottom_position = (element_top_position + element_height);

                //check to see if this current container is within viewport
                if (element_top_position <= window_bottom_position) {
                    $(function () {
                        var el = $('.product-item');
                        var index = 0;
                        var timer = window.setInterval(function () {
                            if (index < el.length) {
                                el.eq(index++).addClass('product-item-show');
                            } else {
                                window.clearInterval(timer);
                            }
                        }, 200);
                    });
                }
            });
        }
        $window.on('scroll orientationchange resize', check_if_in_view);
        $window.trigger('scroll');
        const updateProperties = (elem, state) => {
            elem.style.setProperty('--x', `${state.x}px`)
            elem.style.setProperty('--y', `${state.y}px`)
            elem.style.setProperty('--width', `${state.width}px`)
            elem.style.setProperty('--height', `${state.height}px`)
            elem.style.setProperty('--radius', state.radius)
            elem.style.setProperty('--scale', state.scale)
        }





        // Start Product Js
        $(".product-description-accordion").each(function () {
            var $this = $(this);
            $this.find("h6").on("click touch", function () {
                $(".product-description-accordion").removeClass("active")
                $(".product-description-accordion-content").slideUp();
                if ($this.find(".product-description-accordion-content:visible").length) {
                    $(".product-description-accordion").removeClass("active")
                    $(".product-description-accordion-content").slideUp();
                } else {
                    $this.addClass("active")
                    $(".product-description-accordion-content").slideUp();
                    $this.find(".product-description-accordion-content").slideDown();
                }
            })
        })

        if ($('.product-image').length) {
            $('.product-image').slick({
                autoplay: false,
                autoplaySpeed: 1500,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                asNavFor: '.product-thumb',
                adaptiveHeight: true,
                // dots: true,
                responsive: [
                    {
                      breakpoint: 991,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                      }
                    }
                  ]
            });
            $('.product-thumb').slick({
                autoplay: false,
                autoplaySpeed: 1500,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: false,
                vertical: true,
                centerMode: true,
                centerPadding: '0px',
                focusOnSelect: true,
                asNavFor: '.product-image',
            })

           
            $(window).on('resize', function () {
                $('.product-description-thumb-wrap').slick('resize');
                $('.testimonial-logo-wrap').slick('resize');
            });
        }

        $('.highlighted-products__image').slick({
            autoplay: false,
            autoplaySpeed: 1500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            adaptiveHeight: true,
            // dots: true,
            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                  }
                }
              ]
        });

        $('.thumb-arrow__down').click(function(){
            $(this).parent().parent().find('.slick-slider').slick('slickNext');
        });        
        $('.thumb-arrow__up').click(function(){
            $(this).parent().parent().find('.slick-slider').slick('slickPrev');
        });
        $('.gall-arrow__right').click(function(){
            $(this).parent().parent().find('.slick-slider').slick('slickNext');
        });        
        $('.gall-arrow__left').click(function(){
            $(this).parent().parent().find('.slick-slider').slick('slickPrev');
        });
        // End Product Js

        // Start Shop Js
        $('.shop-tab-trigger ul li').click(function () {
            // $('.shop-tab-trigger ul li').removeClass('tab-active');
            // $(this).addClass('tab-active');
            // $('.shop-tab-item-wrap .shop-tab-item').hide();

            var activeTab = $(this).find('a').attr('href');
            $(activeTab).fadeIn();
            return false;
        });
        $('.shop-trigger-sort').click(function () {
            $(this).parent().find('.shop-tab-trigger ul').slideToggle();
        });



        if ($window.width() < 769) {
            $('.shop-tab-trigger-wrap').each(function () {
                var $$this = $(this);
                $$this.find('.tab-mobi-text em').click(function () {
                    $(this).parent('.shop-tab-trigger').addClass('dropdown-active');
                    $$this.find('.shop-tab-trigger').find('ul').slideToggle();
                })
                $$this.find('.shop-tab-trigger ul li').click(function () {
                    var valText = $(this).text(),
                        showText = $$this.find('.tab-mobi-text em')
                    // console.log(valText)
                    $('.shop-tab-trigger ul li').removeClass('dropdown-inner-active')
                    $(this).parents('.shop-tab-trigger').addClass('dropdown-inner-active')
                    $(this).parents('.shop-tab-trigger').addClass('dropdown-inner-active')
                    $$this.find('.shop-tab-trigger').removeClass('dropdown-active')
                    $$this.find('.shop-tab-trigger').find('ul').slideUp();
                    showText.text(valText);
                    // var goto_location = $(this).find('a').attr('href');
                    // window.location.href = goto_location;
                    // location.reload();
                })
            })


        }

        // End Shop Js




        // if($('.add-to-cart-btn').length > 0) {
        //     var btnDistance = $('.add-to-cart-btn').offset().top;
        //     $(window).on('scroll', function () {
        //         var scrollY = $(this).scrollTop();
        //         if (scrollY > btnDistance) {
        //             $('.sticky-cart').show();
        //             $('body').addClass('sticky-btn-show');
        //         } else {
        //             $('.sticky-cart').hide();
        //             $('body').removeClass('sticky-btn-show');
        //         }
        //     })
        // }


        // sticky button show/hide
        function isOnScreen(elem) {
            // if the element doesn't exist, abort
            if( elem.length == 0 ) {
                return;
            }
            var $window = jQuery(window)
            var viewport_top = $window.scrollTop()
            var viewport_height = $window.height()
            var viewport_bottom = viewport_top + viewport_height
            var $elem = jQuery(elem)
            var top = $elem.offset().top
            var height = $elem.height()
            var bottom = top + height
        
            return (top >= viewport_top && top < viewport_bottom) ||
            (bottom > viewport_top && bottom <= viewport_bottom) ||
            (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
        }
        
        jQuery( document ).ready( function() {
            window.addEventListener('scroll', function(e) {
                if( isOnScreen( jQuery( '.add-to-cart-btn' ) ) ) { /* Pass element id/class you want to check */
                    $('.sticky-cart').hide();
                    $('body').removeClass('sticky-btn-show');
                 }else{
                    $('.sticky-cart').show();
                    $('body').addClass('sticky-btn-show');
                 }
            });
        });
        // end sticky button show/hide




        // image zoom for mobile
        // $('.mob-main-image').click(function(){
        //     $(this).toggleClass('image-zoom');
        // });
        // $(".mob-main-image").pinchzoomer();

        // if($window.width() <= 767){
        //     $(".mob-main-image").pinchzoomer();
        // }

        var ssslider = $(".product-image");
        var hold = false;
        //   $('.product-image__wrapper').on( "dblclick", function() {
        //     ssslider.slick("slickSetOption", "accessibility", hold);
        //     ssslider.slick("slickSetOption", "draggable", hold);
        //     ssslider.slick("slickSetOption", "swipe", hold);
        //     ssslider.slick("slickSetOption", "touchMove", hold);
        //     hold = !hold;
        // });

        var tapped=false
        $(".product-image__wrapper").on("touchstart",function(e){
            if(!tapped){ 
            tapped=setTimeout(function(){
                tapped=null
            },300);
            } else {
            clearTimeout(tapped); //stop single tap callback
            tapped=null
            ssslider.slick("slickSetOption", "accessibility", hold);
            ssslider.slick("slickSetOption", "draggable", hold);
            ssslider.slick("slickSetOption", "swipe", hold);
            ssslider.slick("slickSetOption", "touchMove", hold);
            hold = !hold;
            }
            // e.preventDefault()
        });

    
        



        if ($('.product-content-wrap').length) {
            if ($(window).width() > 700) {
                var cartHeight = $('.sticky-cart').outerHeight() + 60;
                $('.main-footer-section').css({
                    'padding-bottom': cartHeight
                })
            }
        }

    }) // End ready function.

})(jQuery);



// var window_height = $(window).innerHeight();
// $('.your-cart-wrap').css('height', window_height);



var mac = 0;
if (navigator.userAgent.indexOf('Mac') > 0) {
    mac = 1;
} else {
    mac = 0;
}
if (1 == mac) {
    $('body').addClass('mac-os');
} else {
    $("body").addClass('win-os');
}

function increaseCount(e, el) {
    var input = el.previousElementSibling;
    var value = parseInt(input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    input.value = value;
}

function decreaseCount(e, el) {
    var input = el.nextElementSibling;
    var value = parseInt(input.value, 10);
    if (value > 1) {
        value = isNaN(value) ? 0 : value;
        value--;
        input.value = value;
    }
}


$('.testimonial-logo-wrap').slick({
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 2,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    dots: false,
    responsive: [
        {
            breakpoint: 768,
            settings: 'unslick'
    }
]
});

$('.text-image-slider__images').slick({
    // autoplay: false,
    // autoplaySpeed: 1500,
    slidesToShow: 2,
    slidesToScroll: 1,
    // mobileFirst: true,
    arrows: false,
    dots: false,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
    }
]
})

//Implementing navigation of slides using mouse scroll
// $('.text-image-slider__images').on('wheel', (function(e) {
//     e.preventDefault();
//     if (e.originalEvent.deltaY < 0) {
//         $(this).slick('slickPrev');
//     } else {
//         $(this).slick('slickNext');
//     }
//   }));



$('.text-image-slider__arrow_right').click(function(){
    $(this).parent().parent().parent().parent().find('.text-image-slider__images').slick('slickNext');
    var currentSlide = $(this).parent().parent().parent().parent().find('.text-image-slider__images').slick('slickCurrentSlide') + 1;
    $(this).parent().find('span').text(currentSlide);
    $(this).parent().parent().find('span').text(currentSlide);
})

$('.text-image-slider__arrow_left').click(function(){
    $(this).parent().parent().parent().parent().find('.text-image-slider__images').slick('slickPrev');
    var currentSlide = $(this).parent().parent().parent().parent().find('.text-image-slider__images').slick('slickCurrentSlide') + 1;
    $(this).parent().find('span').text(currentSlide);
    $(this).parent().parent().find('span').text(currentSlide);
})
$('.text-image-slider__images').on('swipe', function(event, slick, direction){
    var current_slide = $(this).slick('slickCurrentSlide') + 1;
    $(this).parent().find('.text-image-slider__nav span').text(current_slide);
    // left
  });


//---- insert article inside product grid
/*
$('.collection-custom-blocks .product-item').each(function(){
    var block_position = $(this).attr('data-position');
    block_position = parseInt(block_position) - 1;    
    var related_colection = $(this).attr('data-collection');

    var block_html = $(this).prop("outerHTML");
    // console.log("HTML position"+block_position +": " + block_html);
    $(block_html).insertAfter( related_colection+" .product-item-wrap .product-item:nth-child("+block_position+")");
  })
*/
$('.collection-custom-blocks .product-item').each(function(){
    var block_position = $(this).attr('data-position');
    block_position = parseInt(block_position, 10);
    var related_collection = $(this).attr('data-collection');

    // Only proceed if related_collection is defined and block_position is a valid positive integer
    if (related_collection && !isNaN(block_position) && block_position > 0) {
        var block_html = $(this).prop("outerHTML");
        var selector = related_collection + " .product-item-wrap .product-item:nth-child(" + block_position + ")";
        try {
            if ($(selector).length) {
                $(block_html).insertAfter(selector);
            }
        } catch (e) {
            console.error("Invalid selector for insertAfter:", selector, e);
        }
    }
})


//   cart note checkbox
$('.note-check').change(function(){
    $(this).parent().parent().toggleClass('show-note');
})



// var my_url = window.location.href.split('#');
// var my_tab = my_url[1];
// console.log("the tab is:"+my_tab);
// if(!my_tab != undefined){
//     $('.shop-tab-trigger-wrap ul li').removeClass('tab-active');
//     $('.tab-'+my_tab).addClass('tab-active');
//     $('.shop-tab-item').css('display', 'none');
//     $('#tab-'+my_tab).css('display', 'block');

//     $('.tab-mobi-text > em').text($('.tab-'+my_tab+' a').text());
    
    
// }


$('.product-info-video-play').click(function(e){
    e.preventDefault();
    $('body').addClass('video-shown');
    $('.video-play').get(0).play();
});
$('.product-info__video-backdrop').click(function(){
    $('body').removeClass('video-shown');
    $('.video-play').get(0).pause();
});
$('.video-close').click(function(){
    $('body').removeClass('video-shown');
    $('.video-play').get(0).pause();
});



// subscription
var selected_plan = "false";
var data = {};
$('.plan-selector').change(function(){
    selected_plan = $('.plan-selector:checked').attr('data-plan');
    if(selected_plan == 'false'){
        // ONE TIME
        $('.selling-plan-inp').attr('name', 'no-plan');
        if($('.varaint__item').length > 0){
            var oneTimePrice = $('.varaint__item.active').data('price');
        } else {
            var oneTimePrice = $('.plan-selector:checked').parent().find('.one-time-price').html();
        }
        $('.prod-price').html(oneTimePrice);
    }else{
        // SUBSCRIPTION
        $('.selling-plan-inp').attr('name', 'selling_plan');
        if($('.varaint__item').length > 0){
            var subscriptionPrice = $('.varaint__item.active').data('subscription-price')+"<em>/mo</em>";
        } else {
            var subscriptionPrice = $('.plan-selector:checked').parent().find('.subscription-price').html();
        }
        $('.prod-price').html(subscriptionPrice);
    }
})

$('.sticky-plan').change(function(){
    var sticky_selected_plan = $('.sticky-plan:checked').attr('data-price');
    var sticky_plan_name = $('.sticky-plan:checked').attr('data-plan-name');
    $('.sticky-cart-content-right p').text(sticky_selected_plan);
    $('.sticky-cart-content-right em').text(sticky_plan_name);
})

function open_atc_confirmation(){
    $('body').addClass('show-confirmation');
    $('.add-to-cart-btn').removeClass('loading');
}
$('.goto-chk').click(function(){
    $('body').addClass('cartShown');
    $('body').removeClass('show-confirmation');
});
$('.close-mod, .backdrop, .atc-confirmation__close').click(function(){
    $('body').removeClass('show-confirmation');
});

//------------ Ajax cart
        
$('.single-atc').click(function(e){
    e.preventDefault()
    $(this).parent().addClass('loading');
    var the_title = $(this).attr('data-title');
    $('.atc-confirmation__title').text(the_title);
    // if(selected_plan == 'false'){
    //     data = $('.single-product-form').serialize();
    // }else{
    //      data = {
    //         "id": 41479537131692,
    //         "quantity": 1,
    //         "selling_plan": selected_plan
    //       }
    // }

    var added_product = $(this).attr('data-product');
    fetch('/products/'+added_product+'?section_id=product-recommendations')
    .then(response => response.text())
    .then(cartData => {
        var cart_html = $(cartData);
        var cart_count = $('.recommended-products' , cart_html);
        $('.atc-confirmation .recommended-products').replaceWith(cart_count);
    });
    
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $('.single-product-form').serialize(),
          success: function(data) {
            open_atc_confirmation();
            get_cart_details();
          },
          error: 'addToCartFail'
      });
  })



  $('.single-sticky-atc').click(function(e){
    e.preventDefault()
    $(this).parent().addClass('loading');
    var the_title = $(this).attr('data-title');
    $('.atc-confirmation__title').text(the_title);

    var added_product = $(this).attr('data-product');
    fetch('/products/'+added_product+'?section_id=product-recommendations')
    .then(response => response.text())
    .then(cartData => {
        var cart_html = $(cartData);
        var cart_count = $('.recommended-products' , cart_html);
        $('.atc-confirmation .recommended-products').replaceWith(cart_count);
    });
    
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $(this).parent().parent().parent().parent().find('.shopify-product-form').serialize(),
          success: function(data) {
            open_atc_confirmation();
            get_cart_details();
          },
          error: 'addToCartFail'
      });
  })


  $('.card-atc-btn').click(function(e){
    e.preventDefault()
    $(this).parent().addClass('loading');
    var the_title = $(this).parent().parent().parent().find('h6').text();
    $('.atc-confirmation__title').text(the_title);

    var added_product = $(this).attr('data-product');
    fetch('/products/'+added_product+'?section_id=product-recommendations')
    .then(response => response.text())
    .then(cartData => {
        var cart_html = $(cartData);
        var cart_count = $('.recommended-products' , cart_html);
        $('.atc-confirmation .recommended-products').replaceWith(cart_count);
    });

    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $(this).parent().serialize(),
          success: function(data) {
            open_atc_confirmation();
            get_cart_details();
          },
          error: 'addToCartFail'
      });
      
  });

  $(document).on('click', '.card-atc-btn-up', function(e){
    e.preventDefault()
    $(this).parent().addClass('loading');
    var the_title = $(this).parent().parent().parent().find('h6').text();
    $('.atc-confirmation__title').text(the_title);

    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $(this).parent().serialize(),
          success: function(data) {
            $('body').addClass('cartShown');
            $('body').removeClass('show-confirmation');
            get_cart_details();
          },
          error: 'addToCartFail'
      });
      
  })

  $(document).on('click', '.cart-upsell__atc', function(e){
    e.preventDefault()
    $(this).addClass('loading');
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $(this).parent().serialize(),
          success: function(data) {
            get_cart_details();
          },
          error: 'addToCartFail'
      });
  })

//   $('.cart-upsell__atc').click(function(e){
//     e.preventDefault()
//     $(this).addClass('loading');
//     $.ajax({
//           type: 'POST', 
//           url: '/cart/add.js',
//           dataType: 'json', 
//           data: $(this).parent().serialize(),
//           success: function(data) {
//             get_cart_details();
//           },
//           error: 'addToCartFail'
//       });
      
//   })


function update_cart_data(){
    fetch('/?section_id=cart-drawer')
        .then(response => response.text())
        .then(cartData => {
            var cart_html = $(cartData);
            var cart_items = $('.product-cart-item-wrap' , cart_html);
            var upsell_items = $('.cart-upsell' , cart_html);
            var sample_items = $('.free-sample__items' , cart_html);
            var sample_button = $('.sample-btn-wrap' , cart_html);
            var sample_status = $('.free-sample__heading' , cart_html);
            var cart_total_amount = $('.cart-total-amount' , cart_html);
            var shipping_progress = $('.shipping-progress-wrap' , cart_html);
            $('.shipping-progress-wrap').replaceWith(shipping_progress);

            var upsell_stat = $('.bag-upsell-wrap' , cart_html);
            $('.bag-upsell-wrap').replaceWith(upsell_stat);

            $('.product-cart-item-wrap').replaceWith(cart_items);
            $('.free-sample__items').replaceWith(sample_items);
            $('.sample-btn-wrap').replaceWith(sample_button);
            $('.free-sample__heading').replaceWith(sample_status);
            $('.cart-upsell').replaceWith(upsell_items);
            $('.cart-total-amount').replaceWith(cart_total_amount);

            var item_remains = $('.product-cart-item-wrap').children().length;
            if(item_remains == 0){
                $('.your-cart-inner').addClass('no-item');
            }else{
                $('.your-cart-inner').removeClass('no-item');
            }
            
            console.log('child length: ' + item_remains);

            setTimeout(
                function() 
                {
                    $('.cart-upsell__items').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        asNavFor: '.cart-upsell__offer',
                        prevArrow: "<div class='hero__slider-arrow hero__slider-arrow_left'><img src='https://cdn.shopify.com/s/files/1/2318/2001/files/arl.svg?v=1664546225'></div>",
                        nextArrow: "<div class='hero__slider-arrow hero__slider-arrow_right'><img src='https://cdn.shopify.com/s/files/1/2318/2001/files/arr.svg?v=1664546225'></div>"
                      });
                      $('.cart-upsell__offer').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        asNavFor: '.cart-upsell__items'
                      });
                }, 500);
        });

        fetch('/?section_id=header')
        .then(response => response.text())
        .then(cartData => {
            var cart_html = $(cartData);
            var cart_count = $('.cart-count-wrap' , cart_html);
            $('.cart-count-wrap').replaceWith(cart_count);
        });
}

// ----------------- Get cart details -------------\\
function get_cart_details(){
$.getJSON('/cart.js', function(cart) {
    // The cart data    
    var cart_items = cart.items;
    product_total_price = cart.total_price;
    console.log(cart);
    addRemoveFreeProduct(cart);

    // $('body').addClass('cartShown');
    $('.cart').removeClass('cart-empty');
    $('.cart-total-amount').text(my_Shop_Currency+((product_total_price * 0.01).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ","));      
 
  
    $('.add-to-cart-btn').removeClass('loading');
    $('.shopify-product-form').removeClass('loading');
    $('.sticky-cart-btn').removeClass('loading');
    $('.free-sample__button').removeClass('loading');
    $('.cool-btn').removeClass("loading");

    update_cart_data();

    
    let cartLength = cart_items.length - 1;
    for(var i=0; i<=cartLength; i++){
        console.log(cart_items[i].id);
        var product_id = cart_items[i].id; 
        $('.'+product_id).addClass('upsell__added');
        $('.your-cart-inner').removeClass('no-item');
    } 
    // if(product_total_price <= min_order_value){
    //     clearCart();
    //  }


    });     
}


function addRemoveFreeProduct(cart) {
    let variantID = $('.your-cart-inner').data('free-product');
    let minimum_spend = $('.your-cart-inner').data('minimum-spend') > 1 ? $('.your-cart-inner').data('minimum-spend')*100 : 0 ;
    let freeProdPrice = $('.your-cart-inner').data('free-prod-price') > 1 ? $('.your-cart-inner').data('free-prod-price') : 0 ;
    let cartTotal = cart.total_price;
    let qualify = false;
    let inArray = false;
    let oneTimeTotal = 0;
    for(var i = 0; i< cart.items.length; i++){
        if(cart.items[i].id == variantID){
            inArray = true;
            freeProdPrice = cart.items[i].line_price;
        } else {
            if(!cart.items[i].selling_plan_allocation) {
                oneTimeTotal = oneTimeTotal + cart.items[i].final_line_price
            }
        }
    }
    if(inArray == true ){
        cartTotal = cartTotal - freeProdPrice;
    }
    if(oneTimeTotal > minimum_spend){
        qualify = true;
    }
console.log(non_elig);
    if(inArray == false && qualify == true){
        if(cart.item_count >= 1){
            data = {
                "id": variantID,
                "quantity": 1
            }
            $.ajax({
                type: 'POST', 
                url: '/cart/add.js',
                dataType: 'json', 
                data: data,
                success: function(data) {
                    update_cart_data();
                },
                error: 'addToCartFail'
            });
        }
    }else if(inArray == true && qualify == false){
        if(cart.item_count <= 2){
            var data = {
                "id": parseFloat(variantID),
                "quantity": 0,
              }
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: data,
                dataType: 'json',
                success: function(res) {
                    update_cart_data();
                },
                    error: 'addToCartFail'
            });
        }

    }

    // if(cart.item_count >= 2){
    //     if(variantID > 0 ){
    //         if(inArray == false) {
    //             data = {
    //                 "id": variantID,
    //                 "quantity": 1
    //             }
    //             $.ajax({
    //                 type: 'POST', 
    //                 url: '/cart/add.js',
    //                 dataType: 'json', 
    //                 data: data,
    //                 success: function(data) {
    //                     update_cart_data();
    //                 },
    //                 error: 'addToCartFail'
    //             });
    //         }
    //     }
    // } else {
    //     var data = {
    //         "id": parseFloat(variantID),
    //         "quantity": 0,
    //       }
    //     $.ajax({
    //         type: 'POST',
    //         url: '/cart/change.js',
    //         data: data,
    //         dataType: 'json',
    //         success: function(res) {
    //             product_total_price = res.items_subtotal_price;      
    //             var pro_data = res.items;
    //             var price = res.total_price;
    //             price = price/100;
    //             var tot_qty = res.item_count;
        
    //             $('.cart-total-amount').text(my_Shop_Currency+((product_total_price * 0.01).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ","));   
                
    //             if(tot_qty >=1){
    //                 $('.cart-empty').removeClass('cart__blank');
    //             }else{
    //                 $('.your-cart-inner').addClass('no-item');
    //             }


    //             update_cart_data();
    //             $('.product-cart-item-'+variantID).remove();
    //         },
    //             error: 'addToCartFail'
    //     });
    // }
}



function increaseItemCount(e , el){
    var myElement = el;
  var $input = myElement.previousElementSibling;
  var value = parseInt($input.value);  
  if (value < 100) {
    value = value + 1;
  } else {
    value =100;
  }  
  $input.value = value;            
    change_qty($input);
  }
  
function decreaseItemCount(e , el){
    var $input = el.nextElementSibling;
    var value = parseInt($input.value);  
    if (value > 1) {
    value = value - 1;
    } else {
    value = 0;
    $(el).parent().parent().parent().parent().parent().remove();
    fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then(cartData => {
        var cart_html = $(cartData);
        // var cart_items = $('.product-cart-item-wrap' , cart_html);
        var upsell_items = $('.cart-upsell' , cart_html);
        // $('.product-cart-item-wrap').replaceWith(cart_items);
        $('.cart-upsell').replaceWith(upsell_items);
    });
    }  
    $input.value = value;
    change_qty($input);
}

function change_qty($input){
var variant_id= $($input).attr("data-id");
var quantity= $($input).val();          
var data = { updates: {} };
data.updates[variant_id] = quantity;
jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(res) {               
        product_total_price = res.total_price;
        var pro_data = res.items;              
        var price = res.total_price ;
        price = price/100;
        var tot_qty = res.item_count;
        var the_line_price = res.final_line_price;
        addRemoveFreeProduct(res);
        
        var sample_item_count = $('.free-sample-item').length;
        var item_without_sample = tot_qty - sample_item_count - non_elig_count ;
        if(item_without_sample <=1){
            remove_sample_products();
        }
        // if(res.item_count <=2){
        //     clear_free_item();
        //  }

        $('.cart-total-amount').text(my_Shop_Currency+((product_total_price * 0.01).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ","));   
        
        
        jQuery.each(pro_data, function(index, item) {
            var spe_price=item.final_line_price;
            spe_price= spe_price/100;
            if(item.id == variant_id){
            $('.total-amount span[data-id='+item.id+']').html(my_Shop_Currency + spe_price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            }
        });    

        if(tot_qty >=1){
            // $('.cart-empty').removeClass('cart__blank');
        }else{
            $('.your-cart-inner').addClass('no-item');
        }
        
        fetch('/?section_id=cart-drawer')
        .then(response => response.text())
        .then(cartData => {
            var cart_html = $(cartData);
            var cart_items = $('.product-cart-item-wrap' , cart_html);
            $('.product-cart-item-wrap').replaceWith(cart_items);

            var sample_button = $('.sample-btn-wrap' , cart_html);
            $('.sample-btn-wrap').replaceWith(sample_button);

            var shipping_progress = $('.shipping-progress-wrap' , cart_html);
            $('.shipping-progress-wrap').replaceWith(shipping_progress);

            
        });

        fetch('/?section_id=header')
        .then(response => response.text())
        .then(cartData => {
            var cart_html = $(cartData);
            var cart_count = $('.cart-count-wrap' , cart_html);
            $('.cart-count-wrap').replaceWith(cart_count);
        });

        // if(product_total_price <= min_order_value){
        //     clearCart();
        //  }
    
    }

    
});
};

function removeItem(e , el){
    e.preventDefault();
    var variant_id = $(el).attr('data-id');
    console.log(variant_id);
    var data = { updates: {} };
    data.updates[variant_id] = '0';
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {
       product_total_price = res.items_subtotal_price;      
        var pro_data = res.items;
        var price = res.total_price;
         price = price/100;
         var tot_qty = res.item_count;
         addRemoveFreeProduct(res);
         var sample_item_count = $('.free-sample-item').length;
        var item_without_sample = tot_qty - sample_item_count - non_elig_count ;
        if(item_without_sample <=1){
            remove_sample_products();
        }

         $('.cart-total-amount').text(my_Shop_Currency+((product_total_price * 0.01).toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ","));   
         

             if(tot_qty >=1){
                $('.cart-empty').removeClass('cart__blank');
            }else{
                $('.your-cart-inner').addClass('no-item');
            }

            fetch('/?section_id=cart-drawer')
            .then(response => response.text())
            .then(cartData => {
                var cart_html = $(cartData);
                var cart_items = $('.product-cart-item-wrap' , cart_html);
                var upsell_items = $('.cart-upsell' , cart_html);
                var sample_items = $('.free-sample__items' , cart_html);
                var sample_button = $('.sample-btn-wrap' , cart_html);
                var sample_status = $('.free-sample__heading' , cart_html);
                var cart_total_amount = $('.cart-total-amount' , cart_html);
                var shipping_progress = $('.shipping-progress-wrap' , cart_html);
                $('.shipping-progress-wrap').replaceWith(shipping_progress);

                $('.product-cart-item-wrap').replaceWith(cart_items);
                $('.free-sample__items').replaceWith(sample_items);
                $('.sample-btn-wrap').replaceWith(sample_button);
                $('.free-sample__heading').replaceWith(sample_status);
                $('.cart-upsell').replaceWith(upsell_items);
                $('.cart-total-amount').replaceWith(cart_total_amount);

                var upsell_stat = $('.bag-upsell-wrap' , cart_html);
                $('.bag-upsell-wrap').replaceWith(upsell_stat);
                });

                setTimeout(
                    function() 
                    {
                        $('.product-single-hero-item').removeClass('loading');
                        $('.cart-upsell__items').slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            prevArrow: "<div class='hero__slider-arrow hero__slider-arrow_left'><img src='https://cdn.shopify.com/s/files/1/2318/2001/files/arl.svg?v=1664546225'></div>",
                            nextArrow: "<div class='hero__slider-arrow hero__slider-arrow_right'><img src='https://cdn.shopify.com/s/files/1/2318/2001/files/arr.svg?v=1664546225'></div>"
                          });
                    }, 1000);
                    fetch('/?section_id=header')
        .then(response => response.text())
        .then(cartData => {
            var cart_html = $(cartData);
            var cart_count = $('.cart-count-wrap' , cart_html);
            $('.cart-count-wrap').replaceWith(cart_count);
        });

      }
    });
         $(el).parent().parent().remove();

         
};


function remove_sample_products(){
    var sample_datas = { updates: {} };

    $('.free-sample-item').each(function(){
        var variantID = $(this).attr('data-variant');
        sample_datas.updates[variantID] = 0;
    });
    
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: sample_datas,
        dataType: 'json',
        success: function(res) {
            update_cart_data();
        },
            error: 'addToCartFail'
    });
    
    
}


$(".hero__subtitle a").click(function(e) {
    e.preventDefault();
    var my_section = $(this).attr('href');
    $('html, body').animate({
        scrollTop: $(my_section).offset().top
        // scrollTop: $('.main-content-wrap '+ my_section).offset().top
    }, 1000);
});

$('.testimonial-content-wrap').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    adaptiveHeight: true
});

$('.varaint__selected').click(function(e){
    e.stopPropagation()
    $('.varaint__items').slideToggle();
});
$(document).click(function(){
    $('.varaint__items').slideUp();
});

$('.varaint__item').on('click', function(){
    $('.varaint__item').removeClass('active');
    $(this).addClass('active');
    var selected_var = $(this).attr('data-id');
    var selected_var_title = $(this).text();
    var var_price = $(this).attr('data-price');
    var available = $(this).attr('availability');
    var productSize = $(this).data('product-size');
    $('.varaint__selected').text(selected_var_title);
    $('.atc-var').val(selected_var);
    $('.atc-var').attr('data-productid', selected_var);

    if($('.plan-selector').length > 0){
        var var_sub_price = $(this).attr('data-subscription-price');
        var plan = $('.plan-selector:checked').data('plan');
        if(plan != false ) {
            // SUBSCRIPTION
            $('.prod-price').html(var_sub_price + "<em>/mo</em>");
        } else { 
            // ONE TIME 
            $('.prod-price').html(var_price);
        }
        $('.one-time-price').html(var_price);
        $('.subscription-price').html(var_sub_price + "<em>/mo</em>");
    } else {
        $('.prod-price').html(var_price);
    }

    if(available == 'false'){
        $('.single-atc').addClass('btn_disabled');
    }else{
        $('.single-atc').removeClass('btn_disabled');
    }
    if(productSize != '') {
        $('.prod-price-wrap em').html(productSize);
    }
}); 


$('.variant-radio-pill').on('change', function(){
    var selected_var = $(this).attr('data-id');
    var var_price = $(this).attr('data-price');
    var available = $(this).attr('availability');
    var productSize = $(this).data('product-size');
    if($('.plan-selector').length > 0){
        var var_sub_price = $(this).attr('data-subscription-price');
        var plan = $('.plan-selector:checked').data('plan');
        if(plan != false ) {
            // SUBSCRIPTION
            $('.prod-price').html(var_sub_price + "<em>/mo</em>");
        } else { 
            // ONE TIME 
            $('.prod-price').html(var_price);
        }
        $('.one-time-price').html(var_price);
        $('.subscription-price').html(var_sub_price + "<em>/mo</em>");
    } else {
        $('.prod-price').html(var_price);
    }

    if(available == 'false'){
        $('.single-atc').addClass('btn_disabled');
    }else{
        $('.single-atc').removeClass('btn_disabled');
    }
    if(productSize != '') {
        $('.prod-price-wrap em').html(productSize);
    }


    // slide to variant image
     var variantId = $(this).val();
    var variant = window.productVariants.find(v => v.id == variantId);
// console.log(variant);
    if (!variant || !variant.featured_image) return;

    var imageId = variant.featured_image.id;
    console.log(imageId);
    var $slider = $('.product-image');

    var targetIndex = $slider
        .find('.product-description-thumb')
        .filter(function () {
        return $(this).data('image-id') == imageId;
        })
        .index();

    if (targetIndex >= 0) {
        $slider.slick('slickGoTo', targetIndex - 1);
    }
});

function clear_free_item(){
    var variant_id = $('.your-cart-inner').data('free-product');
    var data = { updates: {} };
    data.updates[variant_id] = '0';
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {
        update_cart_data();
        
      }
    });
    
}

function clearCart(){
    $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() {
        console.log('cart cleared');
        fetch('/?section_id=cart-drawer')
            .then(response => response.text())
            .then(cartData => {
                var cart_html = $(cartData);
                var cart_items = $('.product-cart-item-wrap' , cart_html);
                var upsell_items = $('.cart-upsell' , cart_html);
                var sample_items = $('.free-sample__items' , cart_html);
                var sample_button = $('.sample-btn-wrap' , cart_html);
                $('.product-cart-item-wrap').replaceWith(cart_items);
                $('.cart-upsell').replaceWith(upsell_items);                
                $('.free-sample__items').replaceWith(sample_items);
                $('.sample-btn-wrap').replaceWith(sample_button);
                });
                

                $('.your-cart-inner').addClass('no-item');
                
        },
        error: function(XMLHttpRequest, textStatus) {
          /* error code */
        }
      });
}


// Fade in animation script using Intersection Observer
class FadeInOnScroll {
    constructor(options = {}) {
        this.options = {
            threshold: options.threshold || 0.1,
            rootMargin: options.rootMargin || '0px 0px -50px 0px',
            ...options
        };
        
        this.init();
    }

    init() {
        // Create intersection observer
        this.observer = new IntersectionObserver(
            this.handleIntersection.bind(this),
            this.options
        );

        // Find all elements with fade-in classes
        this.elements = document.querySelectorAll(
            '.fade-in, .fade-in-left, .fade-in-right, .fade-in-scale'
        );

        // Start observing all elements
        this.elements.forEach(el => this.observer.observe(el));
    }

    handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add visible class to trigger animation
                entry.target.classList.add('visible');
                
                // Stop observing this element (animate only once)
                this.observer.unobserve(entry.target);
            }
        });
    }

    // Method to add new elements dynamically
    observe(element) {
        this.observer.observe(element);
    }

    // Method to stop observing (cleanup)
    disconnect() {
        this.observer.disconnect();
    }
}

// Alternative simple function approach
function initFadeInAnimation() {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.fade-in, .fade-in-left, .fade-in-right, .fade-in-scale')
        .forEach(el => observer.observe(el));
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    // Use either approach:
    
    // Option 1: Class-based approach (more flexible)
    const fadeAnimation = new FadeInOnScroll({
        threshold: 0.15, // Trigger when 15% of element is visible
        rootMargin: '0px 0px -100px 0px' // Trigger 100px before element enters viewport
    });
    
    // Option 2: Simple function approach (uncomment to use instead)
    // initFadeInAnimation();
});

// Example of how to add fade-in to dynamically created elements
function addNewContent() {
    const content = document.querySelector('.content');
    const newCard = document.createElement('div');
    newCard.className = 'card fade-in';
    newCard.innerHTML = `
        <h2>Dynamically Added Card</h2>
        <p>This card was added dynamically and will also fade in when scrolled into view.</p>
    `;
    content.appendChild(newCard);
    
    // If using class-based approach, observe the new element
    // fadeAnimation.observe(newCard);
}
